import { useState } from 'react'

import { CanvasModal } from '../canvas-modal'
import styles from './documents-list.module.scss'
import { DocumentItem, DocumentsListProps } from './types'

export const DocumentsList = ({
  title = 'Другие документы',
  list,
  editable,
}: DocumentsListProps) => {
  const [image, setImage] = useState<DocumentItem>()

  if (list && list.length > 0) {
    return (
      <>
        <div className={styles.item}>
          <div className={styles.itemName}>{title}</div>
          <div className={styles.photos}>
            {list.map(item => {
              if (editable) {
                return (
                  <img
                    key={item.id}
                    src={item.file}
                    alt=""
                    className={styles.itemPhoto}
                    onClick={() =>
                      setImage(item)
                    }
                  />
                )
              }
              return (
                <a
                  href={item.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={item.id}
                  className={styles.itemPhoto}
                >
                  <img src={item.file} alt="" />
                </a>
              )
            })}
          </div>
        </div>
        {image && (
          <CanvasModal
            image={image}
            onClose={() => setImage(undefined)}
            editable={editable}
          />
        )}
      </>
    )
  }

  return null
}
